import * as $ from 'jquery';

export const addScript = (src: string): Promise<Event> => {
    return new Promise((resolve, reject) => {
        $(() => {
            const s = document.createElement('script');
            s.setAttribute('src', src);
            s.addEventListener('load', resolve);
            s.addEventListener('error', reject);
            document.body.appendChild(s);
        });
    });
};